import React from 'react';
import { useLanguage } from "../../../hooks/Language";
import { Children } from "react";
import { ParagraphUI } from "./styles";

interface IProps {
    children?: React.ReactNode;
    style?: Record<string, any>;
    theme?: 'dark' | 'light';
    className?: string;
    text: string;
}

const ParagraphDangerous: React.FC<IProps> = ({ children, style, theme, className, text }) => {
    const { translate } = useLanguage();

    return <ParagraphUI dangerouslySetInnerHTML={{ __html: text }} className={className} themeValue={theme} style={style} />;
}

export default ParagraphDangerous;